module.exports = __webpack_public_path__ + "static/media/upsell-tab-best-deal.0b020197.png";